routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.pqrsList', {
      url: "/consultas/pqrs",
      template: `<pqrs-list sh-ctrl="shCtrl"></pqrs-list>`,
	  params: {
		id:null
	  }
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/pqrs-list/pqrs-list.config.js
 **/